var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDeleteAct = function SvgDeleteAct(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "06.-Health-Screens\\uD83D\\uDC8A",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1801_DeletionRequest",
    transform: "translate(-1376.000000, -481.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(240.000000, 120.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(0.000000, 172.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1-copy-2",
    transform: "translate(20.000000, 176.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Actions",
    transform: "translate(1090.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left-Copy",
    transform: "translate(26.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,13 C20.208,13 22,14.792 22,17 C22,19.208 20.208,21 18,21 C15.792,21 14,19.208 14,17 C14,14.792 15.792,13 18,13 Z M10,12 C11.1910713,12 12.9114826,12.26666 14.4519397,12.7982044 C13.2577307,13.8069698 12.5,15.3149962 12.5,17 C12.5,17.7059159 12.63299,18.3807704 12.8752824,19.0008756 L2,19 L2,16 C2,13.34 7.33,12 10,12 Z M20,16.6 L16,16.6 L16,17.4 L20,17.4 L20,16.6 Z M10,3 C12.209139,3 14,4.790861 14,7 C14,9.209139 12.209139,11 10,11 C7.790861,11 6,9.209139 6,7 C6,4.790861 7.790861,3 10,3 Z",
    id: "Combined-Shape",
    fill: "#8F9BA9"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteAct, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete-act.70c07f6b.svg";
export { ForwardRef as ReactComponent };